import kt from "./auth-manager.js";
import t from "../common/base-provider.js";
import ro from "../util/browser-detector.js";
import Ot from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import {
  isArray as R,
  keys as C,
  validateValueIsFromEnum as ta,
  values as Pt,
} from "../util/code-utils.js";
import Mt from "./network-manager.js";
import Wt from "../request-controller.js";
import Bt from "./server-config-manager.js";
import Vt from "./session-manager.js";
import ee, { STORAGE_KEYS as s } from "./storage-manager.js";
import Kt from "./storage-manager-factory.js";
import m from "./subscription-manager.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
import nr from "../DUST/dust-provider-factory.js";
import { subscribeToDust as Gt } from "../DUST/subscribe-to-dust.js";
import bt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as ll } from "../util/url-utils.js";
import { WindowUtils as no } from "../util/window-utils.js";
import { CoreStrings as z } from "../common/constants.js";
import { SupportedOptions as $t, logger as E } from "../../shared-lib/index.js";
import _t from "../models/identifier.js";
const D = {
  Ph: "allowCrawlerActivity",
  Wh: "baseUrl",
  Vh: "noCookies",
  Kh: "devicePropertyAllowlist",
  La: "disablePushTokenMaintenance",
  $h: "enableLogging",
  Yh: "enableSdkAuthentication",
  Ka: "manageServiceWorkerExternally",
  Xh: "minimumIntervalBetweenTriggerActionsInSeconds",
  Zh: "sessionTimeoutInSeconds",
  Qh: "appVersion",
  Xa: "appVersionNumber",
  Ga: "serviceWorkerLocation",
  Ia: "safariWebsitePushId",
  Wa: "localization",
  er: "contentSecurityNonce",
  te: "allowUserSuppliedJavascript",
  $a: "inAppMessageZIndex",
  Ja: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  Oh: "requireExplicitInAppMessageDismissal",
  Za: "doNotLoadFontAwesome",
  tl: "deviceId",
  Ha: "serviceWorkerScope",
  Ne: "dustHost",
  il: "sdkFlavor",
};
class qt {
  constructor() {
    (this.tu = ""),
      (this.sl = ""),
      (this.rl = void 0),
      (this.hl = null),
      (this.eu = null),
      (this.j = null),
      (this.Ru = null),
      (this.h = null),
      (this.C = null),
      (this.B = null),
      (this.vs = null),
      (this.al = ""),
      (this.isInitialized = !1),
      (this.ul = !1),
      (this.cl = new m()),
      (this.fl = new m()),
      (this.options = {}),
      (this.ml = []),
      (this.dl = []),
      (this.jn = []),
      (this.sl = "6.5.0");
  }
  El(t) {
    this.cl.Rt(t);
  }
  mh(t) {
    this.fl.Rt(t);
  }
  initialize(t, i) {
    if (this.ao())
      return E.info("Braze has already been initialized with an API key."), !0;
    this.options = i || {};
    let e = this.re(D.$h);
    const r = ll(no.gl());
    if (
      (r && "true" === r.brazeLogging && (e = !0),
      E.init(e),
      E.info(
        `Initialization Options: ${JSON.stringify(this.options, null, 2)}`,
      ),
      null == t || "" === t || "string" != typeof t)
    )
      return E.error("Braze requires a valid API key to be initialized."), !1;
    this.tu = t;
    let o = this.re(D.Wh);
    if (null == o || "" === o || "string" != typeof o)
      return E.error("Braze requires a valid baseUrl to be initialized."), !1;
    !1 === /^https?:/.test(o) && (o = `https://${o}`);
    const n = o;
    if (
      ((o = document.createElement("a")),
      (o.href = n),
      "/" === o.pathname && (o = `${o}api/v3`),
      (this.al = o.toString()),
      ro.Il && !this.re(D.Ph))
    )
      return (
        E.info("Ignoring activity from crawler bot " + navigator.userAgent),
        (this.ul = !0),
        !1
      );
    const h = this.re(D.Vh) || !1;
    if (
      ((this.B = Kt._l(t, h)), h && this.B.Sl(t), new ee.le(null, !0).jr(s.pe))
    )
      return (
        E.info("Ignoring all activity due to previous opt out"),
        (this.ul = !0),
        !1
      );
    for (const t of C(this.options))
      -1 === Pt($t).indexOf(t) &&
        E.warn(`Ignoring unknown initialization option '${t}'.`);
    const a = ["mparticle", "wordpress", "tealium"];
    if (null != this.re(D.il)) {
      const t = this.re(D.il);
      -1 !== a.indexOf(t)
        ? (this.rl = t)
        : E.error("Invalid sdk flavor passed: " + t);
    }
    let l = this.re($t.Kh);
    if (null != l)
      if (R(l)) {
        const t = [];
        for (let i = 0; i < l.length; i++)
          ta(
            DeviceProperties,
            l[i],
            "devicePropertyAllowlist contained an invalid value.",
            "DeviceProperties",
          ) && t.push(l[i]);
        l = t;
      } else
        E.error(
          "devicePropertyAllowlist must be an array. Defaulting to all properties.",
        ),
          (l = null);
    const u = this.re(D.tl);
    if (u) {
      const t = new _t(u);
      this.B.Iu(s.Ou.tl, t);
    }
    (this.eu = new Ot(this.B, l)),
      (this.h = new Bt(this.B)),
      (this.vs = new bt(this.h, this.B)),
      (this.C = new Vt(this.B, this.vs, this.h, this.re(D.Zh)));
    const c = new m();
    return (
      (this.hl = new kt(this.B, this.re(D.Yh), c)),
      this.q(c),
      (this.j = new Mt(
        this.eu,
        this.B,
        this.hl,
        this.vs,
        this.C,
        this.h,
        this.tu,
        this.al,
        this.sl,
        this.rl || "",
        this.re(D.Qh),
        this.re(D.Xa),
      )),
      (this.Ru = new Wt(
        this.tu,
        this.al,
        this.C,
        this.eu,
        this.vs,
        this.h,
        this.B,
        (t) => {
          if (this.ao()) for (const i of this.gr()) i.N(t);
        },
        this.hl,
        this.j,
      )),
      this.Ru.initialize(),
      h || this.B.Al(),
      E.info(
        `Initialized for the Braze backend at "${this.re(
          D.Wh,
        )}" with API key "${this.tu}".`,
      ),
      rt.t(),
      Gt(),
      this.h.jo(() => {
        var t;
        this.isInitialized &&
          (null === (t = this.h) || void 0 === t ? void 0 : t.Yr()) &&
          import("../FeatureFlags/refresh-feature-flags.js").then((t) => {
            if (!this.isInitialized) return;
            (0, t.default)();
          });
      }),
      this.Ru.rn(() => {
        var t;
        this.isInitialized &&
          (null === (t = this.h) || void 0 === t ? void 0 : t.Yr()) &&
          import("../FeatureFlags/refresh-feature-flags.js").then((t) => {
            if (!this.isInitialized) return;
            (0, t.default)(void 0, void 0, !0);
          });
      }),
      this.cl.L(this.options),
      (this.isInitialized = !0),
      window.dispatchEvent(new CustomEvent("braze.initialized")),
      !0
    );
  }
  destroy(t) {
    if ((E.destroy(), this.ao())) {
      this.fl.L(), this.fl.removeAllSubscriptions();
      for (const t of this.ml) t.destroy();
      this.ml = [];
      for (const t of this.dl) t.clearData(!1);
      this.j && this.j.fo(),
        (this.dl = []),
        this.removeAllSubscriptions(),
        (this.jn = []),
        null != this.Ru && this.Ru.destroy(),
        (this.Ru = null),
        (this.hl = null),
        (this.eu = null),
        (this.j = null),
        (this.h = null),
        (this.C = null),
        (this.vs = null),
        (this.options = {}),
        (this.rl = void 0),
        (this.isInitialized = !1),
        (this.ul = !1),
        t && (this.B = null);
    }
  }
  rr() {
    return !this.Nl() && (!!this.ao() || (console.warn(z.ee), !1));
  }
  _a() {
    return this.tu;
  }
  Sr() {
    return this.hl;
  }
  V() {
    return this.al;
  }
  ue() {
    return this.eu;
  }
  m() {
    return this.j;
  }
  re(t) {
    return this.options[t];
  }
  gr() {
    return this.dl;
  }
  nn() {
    return this.Ru;
  }
  l() {
    return this.h;
  }
  u() {
    return this.C;
  }
  p() {
    return this.B;
  }
  br() {
    if (this.vs && this.Ru) return new User(this.vs, this.Ru);
  }
  ir() {
    return this.vs;
  }
  nr() {
    return !0 === this.re(D.te);
  }
  g(t) {
    let i = !1;
    for (const s of this.ml) s === t && (i = !0);
    i || this.ml.push(t);
  }
  v(i) {
    let s = !1;
    for (const t of this.dl) t.constructor === i.constructor && (s = !0);
    i instanceof t && !s && this.dl.push(i);
  }
  q(t) {
    t instanceof m && this.jn.push(t);
  }
  removeAllSubscriptions() {
    if (this.rr()) for (const t of this.jn) t.removeAllSubscriptions();
  }
  removeSubscription(t) {
    if (this.rr()) for (const i of this.jn) i.removeSubscription(t);
  }
  ge(t) {
    this.ul = t;
  }
  ao() {
    return this.isInitialized;
  }
  Nl() {
    return this.ul;
  }
  tr(t, i) {
    if (!this.rr()) return null;
    return nr.o().Be(t, i);
  }
  Vs() {
    return this.sl;
  }
}
const r = new qt();
export { r as default, qt as BrazeSdkInstance, D as OPTIONS };
